export class LEDGER_ITEM_STATUS  {
    static readonly Outstanding: string = '00000083-1000-0000-0000-000000000001';
    static readonly Paid: string = '00000083-1000-0000-0000-000000000002';
    static readonly Void: string = '00000083-1000-0000-0000-000000000003';
    
}